module.exports = __webpack_public_path__ + "static/media/YM55_4.c11fd85b.jpg";